import React, {useContext} from "react";
import AppContext from "../../store/app-context";
import styles from "./QuoteError.module.css";
import { RefreshCw, AlertTriangle } from "react-feather";

const QuoteError = ({ onRetry }) => {

    const appCtx = useContext(AppContext);

    const defaults = {
        quote_detail_error: "Something went wrong. Please try again.",
        reload_quote_data: "Reload quote data"
    };

    let {
        quote_detail_error,
        reload_quote_data
    } = defaults;

    if (appCtx?.bioradResources) {
        quote_detail_error = appCtx.bioradResources.QuoteDetailError ?? quote_detail_error;
        reload_quote_data = appCtx.bioradResources.ReloadQuoteData ?? reload_quote_data;
    }

    return (
        <div className={styles.container}>
            <div className={styles.errorBox}>
                <span className={styles.errorMessage}>
                    <AlertTriangle height={15} width={30} viewBox="0 2 20 20"/>{quote_detail_error}
                </span>
                <hr className={styles.divider} />
                <button className={styles.retryButton} onClick={onRetry}>
                    <span className={styles.icon}>
                        <RefreshCw height="15" width="15"/>
                    </span> {reload_quote_data}
                </button>
            </div>
        </div>
    );
};

export default QuoteError;